import { useState } from 'react';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../lib/firebase';

interface UploadProgress {
  progress: number;
  url: string | null;
  error: Error | null;
  isUploading: boolean;
}

export function useStorage() {
  const [uploadState, setUploadState] = useState<UploadProgress>({
    progress: 0,
    url: null,
    error: null,
    isUploading: false,
  });

  const uploadFile = (file: File, path: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      if (!storage) {
        const error = new Error("Le service de stockage n'est pas activé sur ce projet Firebase.");
        setUploadState({ progress: 0, url: null, error, isUploading: false });
        return reject(error);
      }

      setUploadState({ progress: 0, url: null, error: null, isUploading: true });

      const storageRef = ref(storage, path);
      const uploadTask = uploadBytesResumable(storageRef, file);

      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          setUploadState(prev => ({ ...prev, progress }));
        },
        (error) => {
          setUploadState({ progress: 0, url: null, error, isUploading: false });
          reject(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          setUploadState({ progress: 100, url: downloadURL, error: null, isUploading: false });
          resolve(downloadURL);
        }
      );
    });
  };

  return { uploadFile, ...uploadState };
}
